/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Icon, Text } from '@az/starc-ui';
import { ArrowRight } from '@az/starc-ui-icons';
import cx from 'classnames';
import { SmartLink } from '@/utils/smartLink';
import styles from './FeaturedCta.module.scss';

export type FeaturedCtaProps = {
  text?: string;
  link?: string;
  compact?: boolean;
};

const FeaturedCta = ({ text, link, compact }: FeaturedCtaProps) => {
  if (!text || !link) {
    return null;
  }

  return (
    <SmartLink to={link} className={cx(styles.FeaturedCta, { [styles.Compact]: compact })}>
      <Text as="span" size="100" className={styles.Text}>
        {text}
      </Text>
      <Icon svg={ArrowRight} className={styles.Icon} attributes={{ 'aria-hidden': true }} />
    </SmartLink>
  );
};

export default FeaturedCta;
